const isEmpty = (value) => {
    // Handle null and undefined
    if (value == null) {
        return true;
    }

    // Handle arrays and array-like objects
    if (Array.isArray(value) || typeof value === 'string' || value instanceof String) {
        return value.length === 0;
    }

    // Handle Maps and Sets
    if (value instanceof Map || value instanceof Set) {
        return value.size === 0;
    }

    // Handle Objects
    if (typeof value === 'object') {
        return Object.keys(value).length === 0;
    }

    // Handle numbers and booleans
    if (typeof value === 'number' || typeof value === 'boolean') {
        return false;
    }

    return true;
};

export default isEmpty;
